
<div class="header-container" style="display: flex; justify-content: space-between;">
    <div class="left-section">
      <mat-form-field appearance="fill" class="import-form-field">
        <mat-select class="custom-backdrop-class import-panel " panelClass="import-select" [(ngModel)]="proType"
          (ngModelChange)="setProType()">
          <mat-option *ngFor="let type of proTypes" [value]="type">{{type}}</mat-option>
        </mat-select>
      </mat-form-field>
  
      <mat-form-field appearance="fill" class="import-form-field">
        <mat-select class="custom-backdrop-class import-panel " panelClass="import-select" [(ngModel)]="proYear"
          (ngModelChange)="setProYear()">
          <mat-option *ngFor="let year of proYears" [value]="year">{{year}}</mat-option>
        </mat-select>
      </mat-form-field>
  
      <mat-radio-group class="import-quarters" aria-label="Select Quarter" [(ngModel)]="proQuarter"
        (ngModelChange)="setProQuarter()">
        <mat-radio-button *ngFor="let quarter of proQuarters" [value]="quarter">{{quarter}}</mat-radio-button>
      </mat-radio-group>
      <button class="action-button" style="margin-left: 14px;" (click)="getPros()">GET PRO</button>
    </div>
  
    <div class="right-section" style="margin-left: 12px;">
      <div *ngIf="importExists" style="display: flex;">
        <span id="pro-status" *ngIf="proStatus" class="status-container"><app-status-dot-icon [status]="proStatus"></app-status-dot-icon> {{proStatus}} </span>
        <button id="approve-button" class="action-button" (click)="approvePro()">Approve</button>
        <button id="export-button" class="action-button" (click)="exportPro()">Export <app-upload-icon [stroke]="'white'"></app-upload-icon></button>
        <button id="filter-button" class="action-button" (click)="showFilterPanel()"><app-filter-panel-icon></app-filter-panel-icon></button>
      </div>
      <button *ngIf="!importExists" id="import-button" (click)="openProImport()">Import PRO</button>
    </div>
  </div>
<!-- STANDARD HTML TABLE APPROACH - START -->
<div class="container">

    <div *ngIf="allPartnerPros.length < 1 && loading == false && getProsBtnClicked == true" class="pro-loader">No Results for {{proType}} {{proYear}} {{proQuarter}}</div>

    <div *ngIf="loading" class="pro-loader">
        <app-loader color="#50e3c2"></app-loader>
    </div>

    <div class="table-container" #scrollContainer (scroll)="onScroll($event)">
        <table class="pro-table" *ngIf="allPartnerPros.length > 0">
            <tr class="header-row">
              <ng-container *ngFor="let col of columns">
                <th *ngIf="col.value != '%USD'" class="column-headers" (click)="getPros(col)">{{col.value}}</th>
              </ng-container>
            </tr>
            <tr *ngFor="let row of allPartnerPros; let i = index" class="data-row">
                <td class="position-cell">{{(tablePage - 1) * tablePageSize + i + 1}}</td>
                <td>{{row.year}}</td>
                <td>{{row.quarter}}</td>
                <td *ngIf="checkColumns('DISTRIBUTION YEAR')">{{row.distributionYear}}</td>
                <td *ngIf="checkColumns('DISTRIBUTION QUARTER')">{{row.distributionQuarter}}</td>
                <td *ngIf="checkColumns('STATEMENT RECIPIENT ID')">{{row.statementRecipientId}}</td>
                <td *ngIf="checkColumns('STATEMENT RECIPIENT NAME')">{{row.statementRecipientName}}</td>
                <td *ngIf="checkColumns('PARTY ID')">{{row.partyId}}</td>
                <td *ngIf="checkColumns('PARTY NAME')">{{row.partyName}}</td>
                <td *ngIf="checkColumns('LEGAL EARNER PARTY ID')">{{row.legalEarnerPartyId}}</td>
                <td *ngIf="checkColumns('LEGAL EARNER PARTY NAME')">{{row.legalEarnerPartyName}}</td>
                <td *ngIf="checkColumns('PERFORMANCE SOURCE')">{{row.performanceSource}}</td>
                <td *ngIf="checkColumns('MUSIC USER GENRE')">{{row.musicUserGenre}}</td>
                <td *ngIf="checkColumns('MUSIC USER')">{{row.musicUser}}</td>
                <td *ngIf="checkColumns('NETWORK SERVICE')">{{row.networkService}}</td>
                <td *ngIf="checkColumns('PERFORMANCE START DATE')">{{row.performanceStartDate | date}}</td>
                <td *ngIf="checkColumns('PERFORMANCE END DATE')">{{row.performanceEndDate | date}}</td>
                <td *ngIf="checkColumns('SURVEY TYPE')">{{row.surveyType}}</td>
                <td *ngIf="checkColumns('DAY PART CODE')">{{row.dayPartCode}}</td>
                <td *ngIf="checkColumns('SERIES OR FILM/ATTRACTION')">{{row.show?.name}}</td> <!-- Assuming 'show' has a 'name' property -->
                <td *ngIf="checkColumns('PROGRAM/EPISODE NAME')">{{row.episodeName}}</td>
                <td *ngIf="checkColumns('WORK ID')">{{row.workId}}</td>
                <td *ngIf="checkColumns('WORK TITLE')">{{row.workTitle}}</td>
                <td *ngIf="checkColumns('CA%')">{{row.allocationPercentage}}</td>
                <td *ngIf="checkColumns('CLASSIFICATION CODE')">{{row.classificationCode}}</td>
                <td *ngIf="checkColumns('NUMBER OF PLAYS')">{{row.numberOfPlays}}</td>
                <td *ngIf="checkColumns('PERFORMANCE TYPE')">{{row.performanceType}}</td>
                <td *ngIf="checkColumns('DURATION')">{{row.duration}}</td>
                <td *ngIf="checkColumns('PERFORMING ARTIST')">{{row.performingArtist}}</td>
                <td *ngIf="checkColumns('COMPOSER NAME')">{{row.composerName}}</td>
                <td *ngIf="checkColumns('EE SHARE')">{{row.eeShare}}</td>
                <td *ngIf="checkColumns('CREDITS')">{{row.credits}}</td>
                <td *ngIf="checkColumns('USD')">{{row.royalty}}</td>
                <!-- <td *ngIf="checkColumns('ADJ_USD')">{{row.adj_usd}}</td> -->
                <td *ngIf="checkColumns('PREMIUM CREDITS')">{{row.premiumCredits}}</td>
                <td *ngIf="checkColumns('PREMIUM ROYALTY')">{{row.premiumRoyalty}}</td>
                <td *ngIf="checkColumns('ADJUSTMENT INDICATOR')">{{row.adjustmentIndicator}}</td>
                <td *ngIf="checkColumns('ADJUSTMENT REASON CODE')">{{row.adjustmentReasonCode}}</td>
                <td *ngIf="checkColumns('ORIGINAL DISTRIBUTION DATE')">{{row.originalDistributionDate | date}}</td>
                <td *ngIf="checkColumns('ROLE TYPE')">{{row.roleType}}</td>
                <td *ngIf="checkColumns('TYPE OF RIGHT')">{{row.typeOfRight}}</td>
                <td *ngIf="checkColumns('TERRITORY')">{{row.territory}}</td>
                <td *ngIf="checkColumns('LICENSOR')">{{row.licensor}}</td>
                <td *ngIf="checkColumns('PROGRAM CODE')">{{row.programCode}}</td>
                <td *ngIf="checkColumns('PERFORMANCE QUARTER')">{{row.performanceQuarter}}</td>
                <td *ngIf="checkColumns('COUNTRY NAME')">{{row.countryName}}</td>
                <td *ngIf="checkColumns('FILE TYPE')">{{row.fileType}}</td>
                <td *ngIf="checkColumns('LICENSOR CODE')">{{row.licensorCode}}</td>
                <td *ngIf="checkColumns('REVENUE CLASS CODE')">{{row.revenueClassCode}}</td>
                <td *ngIf="checkColumns('REVENUE CLASS DESCRIPTION')">{{row.revenueClassDescription}}</td>
                <td *ngIf="checkColumns('ADJUSTMENT DISTRIBUTION DATE')">{{row.adjustentDistributionDate | date}}</td>
                <td *ngIf="checkColumns('CURRENT ACTIVITY AMOUNT')">{{row.currentActivityAmt}}</td>
                <td *ngIf="checkColumns('HIT SONG BONUS')">{{row.hitSongBonus}}</td>
                <td *ngIf="checkColumns('STANDARDS BONUS')">{{row.standardsBonus}}</td>
                <td *ngIf="checkColumns('FOREIGN SOCIETY ADJUSTMENT')">{{row.foreignSocietyAdjustment}}</td>
                <td *ngIf="checkColumns('PERFORMANCE DATE')">{{row.perfDate | date}}</td>
                <td *ngIf="checkColumns('W OR P')">{{row.wOrP}}</td>
                <td *ngIf="checkColumns('SHOW NAME')">{{row.showName}}</td>
                <td *ngIf="checkColumns('PAYMENT TYPE')">{{row.paymentType}}</td>
                <td *ngIf="checkColumns('CHART')">{{row.chart}}</td>
                <td *ngIf="checkColumns('PAY NUMBER')">{{row.payNumber}}</td>
                <td *ngIf="checkColumns('SYND')">{{row.synd}}</td>
                <td *ngIf="checkColumns('STRIP')">{{row.strip}}</td>
                <td *ngIf="checkColumns('PERFORMANCE')">{{row.performance}}</td>
                <td *ngIf="checkColumns('OCCUR')">{{row.occur}}</td>
                <td *ngIf="checkColumns('SOCIETY ABBRV')">{{row.socidetyAbbrv}}</td>
                <td *ngIf="checkColumns('SOCIETY COUNTRY')">{{row.societyCountry}}</td>
            </tr>
        </table>
    </div>
    <app-custom-scroll-bar [scrollContainer]="scrollContainerRef.nativeElement" *ngIf="allPartnerPros.length > 0"></app-custom-scroll-bar>

    <app-custom-pagination *ngIf="allPartnerPros.length > 0" [data]="tableData"></app-custom-pagination>
    <!-- <mat-paginator *ngIf="allPartnerPros.length > 0" [pageSizeOptions]="[25, 50, 100]" showFirstLastButtons></mat-paginator> -->


</div>
<!-- STANDARD HTML TABLE APPROACH - END --> 